import { ImageQuestionConfig } from '@hyper-inferno/image-core';
import {
  QuestionHandler,
  ITransformationContext,
} from '@hyper-inferno/survey-bot-core';

export class ImageHandler implements QuestionHandler<ImageQuestionConfig> {
  async buildConfig(el: any, ctx: ITransformationContext) {
    return el.config;
  }
}
